import { useNavigation } from '@eleveo/components-react';
import { ArrowRightIcon } from '@eleveo/icons-react';
import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';

// eslint-disable-next-line import/no-cycle
import { NavigationList } from './NavigationList';
import { NavItemType } from '../../../utils/navigationUtils';

export interface NavItemProps {
  item: NavItemType;
  openedTree: string;
  pathname: string;
  onClick: (url: string) => void;
}

export const NavItem: React.FC<NavItemProps> = ({
  openedTree,
  pathname,
  onClick,
  item: { url, submenu, title, text, icon, testId },
}) => {
  const { isOpen } = useNavigation();
  const active = pathname.startsWith(url);
  const opened = openedTree && openedTree.startsWith(url);
  const to = submenu ? '#0' : url;

  const handleOnClick = submenu
    ? (e: React.SyntheticEvent<HTMLElement, MouseEvent>) => {
        onClick(url);
        e.preventDefault();
      }
    : undefined;

  return (
    <li
      className={clsx('navigation-item', {
        'navigation-item--selected': active,
        'navigation-item--opened': opened,
        'navigation-item--has-submenu': submenu,
      })}
    >
      <Link
        className="navigation-item__link flex flex-nowrap"
        title={title}
        onClick={handleOnClick}
        to={to}
        data-test-id={testId}
      >
        <span className="navigation-item__icon flex-shrink-0">{icon && icon}</span>
        <span className="navigation-item__label flex items-center justify-start flex-grow" aria-hidden={!isOpen}>
          {text}
        </span>
        {submenu && (
          <span className="navigation-item__arrow flex items-center justify-center">
            <ArrowRightIcon />
          </span>
        )}
      </Link>
      {submenu && (
        <NavigationList items={submenu} openedTree={openedTree} pathname={pathname} setOpenedTree={onClick} />
      )}
    </li>
  );
};
